import Vue from "vue";
import qs from "qs";
import VueRouter from "vue-router";
import store from "../store/index.js";
import products from "./products.js";
import { commonSaveEvaluateInfo } from "../services/question.js";
let query = qs.parse(location.search.slice(1));

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: () => import("../views/home/Home.vue"),
        meta: { name: "首页", title: "理念导入页" },
    },
    {
        path: "/insurance-guide",
        component: () => import("../views/insurance-guide/InsuranceGuide.vue"),
        meta: { name: "购险指南", title: "336理念页" },
    },
    {
        //请勿改动-path，小程序有用到
        path: "/user-report",
        component: () => import("../views/user-report/UserReport.vue"),
        children: [
            {
                path: "share-report",
                component: () =>
                    import("../views/share-report/ShareReport.vue"),
                meta: { title: "报告分享页" },
            },
            {
                path: "risk-explain",
                component: () =>
                    import("../views/risk-explain/RiskExplain.vue"),
                meta: { name: "保障缺口解读", title: "保障缺口解读页" },
            },
            ...products,
        ],
        meta: {
            title: query.tmrId
                ? "报告页-企业微信版客户端"
                : "报告页-测评获客版",
        },
    },
    {
        path: "/login",
        component: () => import("../views/login/Login.vue"),
        meta: { name: "登录", title: "登录页" },
        props: (route) => {
            const { from } = route.query;
            let prop = {};
            if (from) {
                prop.from = from;
                if (/question/.test(from)) {
                    prop.next = commonSaveEvaluateInfo(store.state.answer);
                }
            }

            return prop;
        },
    },
    {
        path: "/member-login",
        component: () => import("../views/member-login/MemberLogin.vue"),
        meta: { name: "登录", title: "登录页" },
        props: (route) => {
            const { saveKey, from } = route.query;
            let prop = {
                saveKey,
            };
            if (from) {
                prop.from = from;
                if (/question/.test(from)) {
                    prop.next = commonSaveEvaluateInfo(store.state.answer);
                }
            }

            return prop;
        },
    },
    {
        path: "/wx-login",
        component: () => import("../views/wx-login/WXLogin.vue"),
        meta: { name: "登录", title: "登录页" },
        props: (route) => {
            const { saveKey, from, mobile } = route.query;
            let prop = {
                saveKey,
                mobile,
            };
            if (from) {
                prop.from = from;
                if (/question/.test(from)) {
                    prop.next = commonSaveEvaluateInfo(store.state.answer);
                }
            }

            return prop;
        },
    },
    {
        path: "/bind-policy-in-h5",
        component: () =>
            import("../views/bind-policy-in-h5/BindPolicyInH5.vue"),
        props: (route) => {
            return {
                from: route.query.from, // 跳到绑定保单时的来源path，二次验证成功时跳回来
            };
        },
        children: [
            {
                path: "private-policy-doc",
                component: () =>
                    import("../components/bind-policy/PrivatePolicyDoc.vue"),
                meta: { title: "隐私政策" },
            },
            {
                path: "user-authorization-doc",
                component: () =>
                    import(
                        "../components/bind-policy/UserAuthorizationDoc.vue"
                    ),
                meta: { title: "个人信息授权书" },
            },
            {
                path: "face-authorization-doc",
                component: () =>
                    import(
                        "../components/bind-policy/FaceAuthorizationDoc.vue"
                    ),
                meta: { title: "人脸信息处理授权书", close: true },
            },
            {
                path: "face-authorization-doc-tx",
                component: () =>
                    import(
                        "../components/bind-policy/FaceAuthorizationDocTx.vue"
                    ),
                meta: { title: "人脸信息处理授权书", close: true },
            },
        ],
        meta: { name: "绑定保单" },
    },
    {
        path: "/bind-policy-again/sms",
        component: () =>
            import("../views/bind-policy-again-sms/BindPolicyAgainSMS.vue"),
        props: (route) => {
            return {
                from: route.query.from, // 跳到绑定保单时的来源path，二次验证成功时跳回来
            };
        },
        meta: { name: "绑定保单" },
    },
    {
        path: "/bind-policy-again/face-success",
        component: () =>
            import(
                "../views/bind-policy-again-face-success/BindPolicyAgainFaceSuccess.vue"
            ),
        props: (route) => {
            return {
                from: route.query.from, // 跳到绑定保单时的来源path，二次验证成功时跳回来
            };
        },
        meta: { name: "绑定保单" },
    },
    {
        path: "/bind-policy-again/face-fail",
        component: () =>
            import(
                "../views/bind-policy-again-face-fail/BindPolicyAgainFaceFail.vue"
            ),
        props: (route) => {
            return {
                from: route.query.from, // 跳到绑定保单时的来源path，二次验证成功时跳回来
            };
        },
        meta: { name: "绑定保单" },
    },
    {
        path: "/other-policy",
        component: () => import("../views/other-policy/OtherPolicy.vue"),
        meta: { name: "绑定保单", title: "绑定保单页" },
    },
    {
        path: "/order-list",
        component: () => import("../views/order-list/OrderList.vue"),
        meta: { name: "我的订单" },
    },
    {
        path: "/order-info/:orderId",
        component: () => import("../views/order-info/OrderInfo.vue"),
        meta: { name: "订单详情" },
    },
    {
        //请勿改动-path，小程序有用到
        path: "/question",
        component: () => import("../views/question/Question.vue"),
        meta: { close: true },
    },
];

export default new VueRouter({
    routes,
});
